import { fetchWithAuth } from './fetchWithAuth';

// 간병정보 목록 조회
export const fetchCareList = async (patient_name, carer1_name, carer2_name, carer3_name, search_dt) => {
  const params = new URLSearchParams();
  if (patient_name) params.append('patient_name', patient_name);
  if (carer1_name)  params.append('carer1_name',  carer1_name);
  if (carer2_name)  params.append('carer2_name',  carer2_name);
  if (carer3_name)  params.append('carer3_name',  carer3_name);
  if (search_dt)    params.append('search_dt',    search_dt);

  return fetchWithAuth(`/care?${params}`);
};

// 간병정보 상세 조회
export const fetchCareDetail = async (seq_no) => {
  return fetchWithAuth(`/care/${seq_no}`);
};

// 간병정보 등록
export const createCare = async (form) => {
  return fetchWithAuth(`/care`, { method: 'POST', body: JSON.stringify(form) });
};

// 간병정보 수정
export const updateCare = async (seq_no, form) => {
  return fetchWithAuth(`/care/${seq_no}`, { method: 'PUT', body: JSON.stringify(form) });
};

// 간병정보 삭제
export const deleteCare = async (seq_no) => {
  return fetchWithAuth(`/care/${seq_no}`, { method: 'DELETE' });
};

// 병원 목록 조회
export const fetchCareHospitalList = async () => {
  return fetchWithAuth(`/care/hospitals`);
};

// 병원 등록
export const createCareHospital = async (hospital_name) => {
  return fetchWithAuth(`/care/hospitals`, { method: 'POST', body: JSON.stringify({ hospital_name }) });
};

// 병원명 수정
export const updateCareHospital = async (hospital_name, new_name) => {
  return fetchWithAuth(`/care/hospitals/${encodeURIComponent(hospital_name)}`, { method: 'PUT', body: JSON.stringify({ new_name }) });
};

// 병원 삭제
export const deleteCareHospital = async (hospital_name) => {
  return fetchWithAuth(`/care/hospitals/${encodeURIComponent(hospital_name)}`, { method: 'DELETE' });
};

// 병원순서 변경
export const updateCareHospitalSortOrder = async (hospital_name, sort_order) => {
  return fetchWithAuth(`/care/hospitals/${encodeURIComponent(hospital_name)}/sort`, { method: 'PUT', body: JSON.stringify({ sort_order }) });
};